export interface TVShow {
  id: string;
  title: string;
  originalTitle: string;
  category: string;
  year: number;
  rating: number;
  episodes: number;
  status: '更新中' | '已完结';
  description: string;
  coverImage: string;
  posterImage: string;
  director: string;
  cast: string[];
  genres: string[];
  region: string;
  updateInfo: string;
  episodeList: Episode[];
  featured?: boolean;
  hot?: boolean;
  new?: boolean;
}

export interface Episode {
  id: string;
  title: string;
  episodeNumber: number;
  duration: string;
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  slug: string;
  count: number;
}

export const categories: Category[] = [
  { id: 'cat-1', name: '国产剧', icon: 'ri-china-railway-line', slug: 'guochan', count: 128 },
  { id: 'cat-2', name: '韩剧', icon: 'ri-kakao-talk-line', slug: 'hanju', count: 96 },
  { id: 'cat-3', name: '美剧', icon: 'ri-flag-line', slug: 'meiju', count: 84 },
  { id: 'cat-4', name: '日剧', icon: 'ri-sun-line', slug: 'riju', count: 72 },
  { id: 'cat-5', name: '动漫', icon: 'ri-rocket-line', slug: 'dongman', count: 156 },
  { id: 'cat-6', name: '综艺', icon: 'ri-tv-line', slug: 'zongyi', count: 64 },
  { id: 'cat-7', name: '港剧', icon: 'ri-building-2-line', slug: 'gangju', count: 48 },
  { id: 'cat-8', name: '台剧', icon: 'ri-map-pin-2-line', slug: 'taiju', count: 36 },
];

export const tvShows: TVShow[] = [
  {
    id: 'show-1',
    title: '繁花',
    originalTitle: 'Blossoms Shanghai',
    category: 'guochan',
    year: 2024,
    rating: 9.2,
    episodes: 30,
    status: '已完结',
    description: '九十年代的上海处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼，跻身成为商界后起之秀。黄河路上无人不晓，平凡阿宝蜕变为宝总，离不开高人爷叔与夜东京老板玲子、外贸大楼汪小姐的鼎力协助。随着神秘女子李李空降黄河路，一家时髦饭店即将搅动整条街，也令宝总原本决胜千里的事业变得动荡惊心，他与身边人的关系也经受着前所未有的考验。于此同时，深圳股市的过江龙强总也随时会给阿宝致命一击。阿宝唯有向前，以赤子之心翻越高山，方可奔赴繁花满眼。',
    coverImage: 'https://readdy.ai/api/search-image?query=Shanghai%20in%201990s%20nostalgic%20golden%20era%20cityscape%20with%20warm%20amber%20lighting%20and%20elegant%20Chinese%20commercial%20district%20atmosphere%20cinematic%20composition%20rich%20textures%20artistic%20film%20poster%20style&width=1600&height=600&seq=show-fanhua-banner&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20poster%20style%20elegant%20man%20in%20suit%20Shanghai%201990s%20retro%20golden%20light%20cinematic%20film%20poster%20composition%20warm%20amber%20tones%20simple%20clean%20background&width=600&height=800&seq=show-fanhua-poster&orientation=portrait',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    genres: ['剧情', '年代', '商战'],
    region: '中国大陆',
    updateInfo: '全30集',
    episodeList: [],
    featured: true,
    hot: true,
  },
  {
    id: 'show-2',
    title: '庆余年 第二季',
    originalTitle: 'Joy of Life Season 2',
    category: 'guochan',
    year: 2024,
    rating: 9.5,
    episodes: 36,
    status: '已完结',
    description: '范闲从澹州初入京都，凭借过人的智谋与勇武在鉴查院崭露头角。庆帝对范闲的态度变得愈发微妙，一场围绕皇权与江湖的巨大阴谋正在缓缓拉开帷幕。范闲在北齐的旅程中经历了生死考验，也与海棠朵朵、司理理等人结下了深厚的情谊。当他回到南庆，更大的挑战等待着他——权力斗争、身世之谜、以及关乎天下苍生的抉择。',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20and%20martial%20arts%20drama%20poster%20style%20hero%20standing%20on%20cliff%20with%20sword%20warm%20golden%20sunset%20light%20cinematic%20epic%20composition%20traditional%20Chinese%20architecture&width=1600&height=600&seq=show-qingyunian-banner&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20hero%20with%20sword%20ancient%20Chinese%20costume%20dramatic%20lighting%20warm%20golden%20tones%20film%20poster%20style%20clean%20background&width=600&height=800&seq=show-qingyunian-poster&orientation=portrait',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    genres: ['古装', '权谋', '武侠'],
    region: '中国大陆',
    updateInfo: '全36集',
    episodeList: [],
    hot: true,
  },
  {
    id: 'show-3',
    title: '与凤行',
    originalTitle: 'The Legend of Shen Li',
    category: 'guochan',
    year: 2024,
    rating: 8.9,
    episodes: 39,
    status: '已完结',
    description: '灵界碧苍王沈璃为掌握自己的命运，在逃婚过程中意外坠落人界，与下凡体验生活的上古神行止相遇。两人在人间相识相知，共同经历种种磨难与考验。当沈璃重返灵界后，行止的真实身份也逐渐浮出水面——他竟是天界最后一位上古神。一段跨越三界的仙侠虐恋就此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20drama%20ethereal%20goddess%20and%20warrior%20in%20celestial%20realm%20floating%20clouds%20magical%20atmosphere%20warm%20golden%20and%20crimson%20lighting%20cinematic%20composition&width=1600&height=600&seq=show-yufenghang-banner&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20drama%20poster%20beautiful%20actress%20in%20ancient%20costume%20ethereal%20magical%20effects%20warm%20golden%20light%20film%20poster%20style%20clean%20background&width=600&height=800&seq=show-yufenghang-poster&orientation=portrait',
    director: '邓科',
    cast: ['赵丽颖', '林更新', '宣璐', '徐海乔'],
    genres: ['古装', '仙侠', '爱情'],
    region: '中国大陆',
    updateInfo: '全39集',
    episodeList: [],
    featured: true,
  },
  {
    id: 'show-4',
    title: '眼泪女王',
    originalTitle: 'Queen of Tears',
    category: 'hanju',
    year: 2024,
    rating: 9.1,
    episodes: 16,
    status: '已完结',
    description: '百货女王洪海仁与超市王子白贤宇，这对财阀夫妇结婚三年后遭遇婚姻危机，却在面对巨大变故时重新发现彼此的爱情。洪海仁出身韩国顶级财阀Queens集团，是百货公司的女王，而白贤宇是龙头里超市的王子。两人从相爱到结婚，再到婚姻出现裂痕，经历了一系列令人心碎又温暖的时刻。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20drama%20elegant%20couple%20in%20luxury%20department%20store%20emotional%20atmosphere%20warm%20golden%20lighting%20cinematic%20composition%20Korean%20drama%20poster%20style&width=1600&height=600&seq=show-tearqueen-banner&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20elegant%20woman%20in%20luxury%20fashion%20emotional%20expression%20warm%20golden%20lighting%20film%20poster%20style%20clean%20simple%20background&width=600&height=800&seq=show-tearqueen-poster&orientation=portrait',
    director: '张英宇',
    cast: ['金秀贤', '金智媛', '朴成焄', '郭东延'],
    genres: ['爱情', '剧情', '家庭'],
    region: '韩国',
    updateInfo: '全16集',
    episodeList: [],
    hot: true,
  },
  {
    id: 'show-5',
    title: '黑暗荣耀',
    originalTitle: 'The Glory',
    category: 'hanju',
    year: 2023,
    rating: 9.3,
    episodes: 16,
    status: '已完结',
    description: '梦想成为建筑师的文东恩，在高中时期因校园暴力而被迫退学。多年后，她成为了加害者孩子的班主任，并开始了一场精心策划的复仇。那些曾经欺凌过她的人，如今过着光鲜亮丽的生活，而文东恩要让这些人一个一个地为自己的罪行付出代价。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20revenge%20drama%20dark%20atmospheric%20school%20corridor%20with%20dramatic%20lighting%20mysterious%20woman%20silhouette%20cinematic%20composition%20cold%20and%20warm%20contrast&width=1600&height=600&seq=show-darkglory-banner&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20mysterious%20elegant%20woman%20dark%20atmospheric%20dramatic%20lighting%20film%20poster%20style%20clean%20simple%20background&width=600&height=800&seq=show-darkglory-poster&orientation=portrait',
    director: '安吉镐',
    cast: ['宋慧乔', '李到晛', '林智妍', '廉惠兰'],
    genres: ['剧情', '复仇', '悬疑'],
    region: '韩国',
    updateInfo: '全16集',
    episodeList: [],
    featured: true,
  },
  {
    id: 'show-6',
    title: '唐朝诡事录之西行',
    originalTitle: 'Strange Tales of Tang Dynasty: Journey to the West',
    category: 'guochan',
    year: 2024,
    rating: 8.8,
    episodes: 36,
    status: '更新中',
    description: '唐玄宗时期，大理寺少卿卢凌风与乾陵丞苏无名一行人一路西行，破获一桩桩离奇诡案。从长安到河西走廊，每一站都暗藏杀机。西域的神秘力量、古老诅咒、离奇死亡，所有线索都指向了一个更大的阴谋。卢凌风与苏无名能否在危机四伏的西域找到真相？',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20mystery%20detective%20drama%20desert%20caravan%20on%20silk%20road%20warm%20golden%20sand%20dunes%20cinematic%20composition%20mysterious%20atmosphere&width=1600&height=600&seq=show-tangchaogui-banner&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20drama%20poster%20Tang%20Dynasty%20detective%20in%20traditional%20costume%20mysterious%20atmosphere%20warm%20tones%20film%20poster%20style%20clean%20background&width=600&height=800&seq=show-tangchaogui-poster&orientation=portrait',
    director: '柏杉',
    cast: ['杨旭文', '杨志刚', '郜思雯', '陈创'],
    genres: ['古装', '悬疑', '探案'],
    region: '中国大陆',
    updateInfo: '更新至28集',
    episodeList: [],
  },
  {
    id: 'show-7',
    title: '墨雨云间',
    originalTitle: 'The Double',
    category: 'guochan',
    year: 2024,
    rating: 8.5,
    episodes: 40,
    status: '已完结',
    description: '县令之女薛芳菲在遭受巨大变故后，被中书令之女姜梨所救。当薛芳菲醒来时，发现自己身处于一个全新的身份中。她被迫接受姜梨的委托，以姜梨的身份回到京城。在京城中，薛芳菲遇到了曾经的恋人萧蘅，两人在重重阴谋中相互扶持，共同揭开了一个惊天秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20drama%20elegant%20woman%20in%20ancient%20Chinese%20garden%20with%20cherry%20blossoms%20warm%20spring%20lighting%20cinematic%20composition%20soft%20romantic%20atmosphere&width=1600&height=600&seq=show-moyuyunjian-banner&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20drama%20poster%20beautiful%20actress%20in%20ancient%20costume%20elegant%20expression%20warm%20romantic%20lighting%20film%20poster%20style%20clean%20background&width=600&height=800&seq=show-moyuyunjian-poster&orientation=portrait',
    director: '侣皓吉吉',
    cast: ['吴谨言', '王星越', '陈鑫海', '梁永棋'],
    genres: ['古装', '爱情', '悬疑'],
    region: '中国大陆',
    updateInfo: '全40集',
    episodeList: [],
    hot: true,
  },
  {
    id: 'show-8',
    title: '三体',
    originalTitle: 'Three-Body',
    category: 'guochan',
    year: 2023,
    rating: 9.0,
    episodes: 30,
    status: '已完结',
    description: '2007年，地球基础科学出现了异常的扰动，一时间科学界风雨飘飘，人心惶惶。离奇自杀的科学家，近乎神迹的倒计时，行事隐秘的科学边界，神秘莫测的《三体》游戏。纳米科学家汪淼被警官史强带到联合作战中心，并潜入名为"科学边界"的组织协助调查。迷雾之中，汪淼接触到一个名为ETO的组织，发现其幕后统帅竟是自杀身亡的科学家杨冬的母亲叶文洁。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20futuristic%20abstract%20cosmic%20three%20body%20problem%20stars%20and%20galaxy%20dark%20space%20with%20warm%20glowing%20elements%20cinematic%20epic%20composition&width=1600&height=600&seq=show-threebody-banner&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%20cosmic%20galaxy%20abstract%20futuristic%20mysterious%20dark%20space%20with%20warm%20glowing%20elements%20film%20poster%20style%20clean%20background&width=600&height=800&seq=show-threebody-poster&orientation=portrait',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    genres: ['科幻', '悬疑', '剧情'],
    region: '中国大陆',
    updateInfo: '全30集',
    episodeList: [],
    featured: true,
  },
  {
    id: 'show-9',
    title: '超异能族',
    originalTitle: 'Moving',
    category: 'hanju',
    year: 2023,
    rating: 9.4,
    episodes: 20,
    status: '已完结',
    description: '一群拥有超能力的人隐藏着自己的能力，过着平凡的生活。然而，一个神秘的快递组织正在追踪他们。为了保护自己的孩子们，这些超能力父母不得不重新面对自己的过去。高中生金奉锡拥有飞行能力，张喜秀拥有再生能力，李强勋拥有怪力。三位少年在成长的过程中，逐渐发现了自己身世的秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20superhero%20drama%20teenagers%20with%20superpowers%20in%20school%20uniform%20dramatic%20action%20pose%20warm%20golden%20lighting%20cinematic%20composition&width=1600&height=600&seq=show-moving-banner&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20superhero%20drama%20poster%20teenagers%20flying%20and%20action%20dramatic%20composition%20warm%20lighting%20film%20poster%20style%20clean%20background&width=600&height=800&seq=show-moving-poster&orientation=portrait',
    director: '朴仁济',
    cast: ['柳承龙', '韩孝周', '赵寅成', '李正河'],
    genres: ['动作', '科幻', '悬疑'],
    region: '韩国',
    updateInfo: '全20集',
    episodeList: [],
  },
  {
    id: 'show-10',
    title: '寄生兽：灰色部队',
    originalTitle: 'Parasyte: The Grey',
    category: 'hanju',
    year: 2024,
    rating: 8.7,
    episodes: 6,
    status: '已完结',
    description: '不明寄生生物从空中降落到地球，以人类为宿主并试图扩张势力。这些寄生生物以人类的大脑为目标，控制宿主身体进行杀戮。在这场浩劫中，一个名叫郑秀仁的女性与寄生生物海蒂形成了奇妙的共生关系，她们共同对抗着寄生生物组织，守护着人类的未来。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20horror%20drama%20dark%20city%20at%20night%20mysterious%20creature%20transformation%20dramatic%20lighting%20cinematic%20composition%20cold%20blue%20and%20warm%20amber%20contrast&width=1600&height=600&seq=show-parasite-banner&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20horror%20drama%20poster%20woman%20with%20half%20transformed%20face%20parasitic%20creature%20dramatic%20dark%20lighting%20film%20poster%20style%20clean%20background&width=600&height=800&seq=show-parasite-poster&orientation=portrait',
    director: '延尚昊',
    cast: ['具教焕', '全素妮', '李贞贤', '权海骁'],
    genres: ['科幻', '恐怖', '动作'],
    region: '韩国',
    updateInfo: '全6集',
    episodeList: [],
    new: true,
  },
  {
    id: 'show-11',
    title: '鬼灭之刃 柱训练篇',
    originalTitle: 'Demon Slayer: Hashira Training Arc',
    category: 'dongman',
    year: 2024,
    rating: 9.3,
    episodes: 8,
    status: '已完结',
    description: '炭治郎等人在经历刀匠村一战后，实力有了显著提升。为了迎接与鬼舞辻无惨的最终决战，他们接受了鬼杀队九柱的严格训练。每一位柱都拥有独特的战斗技巧和训练方法，炭治郎和他的伙伴们在艰苦的训练中不断突破自我，为最终的决战做着准备。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20demon%20slayer%20swordsman%20epic%20battle%20scene%20traditional%20Japanese%20aesthetic%20warm%20fiery%20lighting%20cinematic%20composition%20vibrant%20colors&width=1600&height=600&seq=show-demonslayer-banner&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20demon%20slayer%20character%20with%20sword%20dynamic%20action%20pose%20vibrant%20warm%20colors%20anime%20style%20clean%20background&width=600&height=800&seq=show-demonslayer-poster&orientation=portrait',
    director: '外崎春雄',
    cast: ['花江夏树', '鬼头明里', '下野纮', '松冈祯丞'],
    genres: ['动画', '动作', '奇幻'],
    region: '日本',
    updateInfo: '全8集',
    episodeList: [],
    hot: true,
  },
  {
    id: 'show-12',
    title: '葬送的芙莉莲',
    originalTitle: 'Frieren: Beyond Journey\'s End',
    category: 'dongman',
    year: 2023,
    rating: 9.5,
    episodes: 28,
    status: '已完结',
    description: '魔法使芙莉莲与勇者辛美尔等人历经十年冒险，成功打败了魔王，为世界带来了和平。作为精灵族的芙莉莲，她的寿命远超人类同伴。五十年后，当芙莉莲再次来到人类世界时，昔日的伙伴们已经垂垂老矣。面对即将离世的辛美尔，芙莉莲才意识到自己对人性的了解是多么浅薄。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20elf%20mage%20walking%20through%20beautiful%20fantasy%20landscape%20peaceful%20atmosphere%20warm%20golden%20sunset%20lighting%20cinematic%20composition&width=1600&height=600&seq=show-frieren-banner&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20elf%20mage%20girl%20holding%20staff%20beautiful%20fantasy%20art%20style%20warm%20golden%20lighting%20clean%20background&width=600&height=800&seq=show-frieren-poster&orientation=portrait',
    director: '斋藤圭一郎',
    cast: ['种崎敦美', '市之濑加那', '小林千晃', '上田耀司'],
    genres: ['动画', '奇幻', '冒险'],
    region: '日本',
    updateInfo: '全28集',
    episodeList: [],
    featured: true,
  },
];

export const faqs = [
  {
    question: '久播影院需要注册才能观看吗？',
    answer: '不需要！久播影院所有电视剧资源完全免费，无需注册即可在线观看。我们致力于为用户提供最便捷的观影体验，打开网站就能直接观看您喜欢的电视剧。',
  },
  {
    question: '观看电视剧需要安装播放器吗？',
    answer: '完全不需要。久播影院采用先进的HTML5播放技术，支持所有主流浏览器。您只需要打开网页就能流畅观看，无需下载或安装任何播放器插件。',
  },
  {
    question: '为什么有些剧集显示"更新中"？',
    answer: '部分正在热播的电视剧会显示"更新中"状态，这意味着该剧还在持续更新中。我们会第一时间同步更新最新剧集，建议您收藏该剧集页面，方便随时查看更新进度。',
  },
  {
    question: '久播影院支持哪些设备观看？',
    answer: '久播影院全面支持PC端、平板电脑和手机端观看。我们的网站采用了响应式设计，会自动适配不同屏幕尺寸，无论您使用什么设备，都能获得最佳的观影体验。',
  },
  {
    question: '电视剧的画质怎么样？',
    answer: '久播影院提供720P/1080P高清画质，部分热门剧集还支持4K超清画质。我们采用先进的视频压缩和CDN加速技术，确保高清画质的同时实现流畅不缓冲的观看体验。',
  },
  {
    question: '如何查找我想看的电视剧？',
    answer: '您可以通过首页的分类导航浏览不同类型的电视剧，也可以使用搜索功能直接搜索剧名。我们还提供了热门推荐、最新更新等栏目，帮助您发现更多好看的电视剧。',
  },
];

export const testimonials = [
  {
    name: '王先生',
    location: '北京',
    rating: 5,
    comment: '用了久播影院大半年了，追剧体验真的很好。更新快、画质清晰，最重要的是完全免费，良心网站！',
    date: '2024-07-15',
  },
  {
    name: '李女士',
    location: '上海',
    rating: 5,
    comment: '作为一个追剧达人，久播影院是我最常用的平台。韩剧更新速度超快，画质也好，推荐给所有喜欢看剧的朋友。',
    date: '2024-07-12',
  },
  {
    name: '张同学',
    location: '广州',
    rating: 5,
    comment: '学生党福音！不用充会员就能看高清资源，而且不卡顿。宿舍几个同学都在用，大家都说好。',
    date: '2024-07-10',
  },
  {
    name: '陈女士',
    location: '深圳',
    rating: 5,
    comment: '在家带娃的宝妈一枚，靠追剧续命。久播影院资源丰富，国产剧韩剧都有，更新速度快，画质也棒，五星推荐！',
    date: '2024-07-08',
  },
  {
    name: '刘先生',
    location: '成都',
    rating: 5,
    comment: '对比了好几个免费影视站，久播影院的体验是最好的。界面简洁清爽，没有乱七八糟的广告，看剧很舒服。',
    date: '2024-07-05',
  },
  {
    name: '赵女士',
    location: '杭州',
    rating: 5,
    comment: '从朋友那里知道的久播影院，一试就爱上了。分类很清晰，找剧方便，而且加载速度很快，基本不缓冲。',
    date: '2024-07-03',
  },
];

export const brandInfo = {
  name: '久播影院',
  slogan: '好剧不等待，高清免费看',
  founded: '2020年',
  description: '久播影院成立于2020年，是国内领先的高清电视剧免费在线观看平台。我们致力于为广大用户提供最新、最全、最高清的电视剧资源，涵盖国产剧、韩剧、美剧、日剧、动漫等多种类型。凭借先进的视频播放技术和强大的内容资源，久播影院已为数千万用户提供了优质的在线观影服务。',
  mission: '让每一个人都能免费享受高品质的观影体验',
  vision: '成为全球华人首选的在线视频平台',
  values: ['用户至上', '品质为先', '创新驱动', '开放共享'],
  contact: {
    email: 'support@jiubocinema.com',
    wechat: 'jiubocinema',
    qq: '4001234567',
    workingHours: '周一至周日 9:00-22:00',
  },
  stats: [
    { label: '电视剧资源', value: '10,000+' },
    { label: '日活跃用户', value: '500万+' },
    { label: '累计用户', value: '5000万+' },
    { label: '高清覆盖率', value: '99%' },
  ],
};